module.exports = __webpack_public_path__ + "img/cap2.15c98d95.png";